import { createBrowserRouter } from 'react-router-dom'

import { lkRoutes, lkmRoutes } from './routes'
import { isLkmDomain } from './utils'

export const router = createBrowserRouter(isLkmDomain() ? lkmRoutes : lkRoutes)
